import React, { FC } from "react";
// @ts-ignore
import { Link } from 'react-scroll';

const HeroSection: FC = () => {

    return (
        <section className="hero" id="hero">
            <div className="hero__title">
                <h1>
                    <span>фітнес клуб</span>, що працює на тебе
                </h1>
            </div>
            <div className="hero__subtitle">
                <p>
                    <span>CrossGym</span> - твій фітнес-партнер для досягнення цілей!
                </p>
            </div>
            <div className="hero__nav">
                <Link to="memberships" smooth={true}>Отримати абонемент</Link>
            </div>
        </section>
    );
};

export default HeroSection;
